import { createDisclosure } from "@scripts/disclosure";
import type { ComponentInit } from "@scripts/registry";

export const initFilterDrop: ComponentInit = (root) => {
	if (!(root instanceof HTMLDetailsElement)) return;

	const wasOpen = root.open;
	const listeners = new AbortController();
	const { signal } = listeners;

	document.addEventListener(
		"click",
		(event) => {
			if (root.open && event.target instanceof Node && !root.contains(event.target)) {
				root.open = false;
			}
		},
		{ signal },
	);

	createDisclosure({
		scope: root,
		contains: root,
		isOpen: () => root.open,
		close: (returnFocus) => {
			root.open = false;

			if (returnFocus) root.querySelector<HTMLElement>("[data-fa-filter-drop-pill]")?.focus();
		},
		signal,
	});

	return () => {
		listeners.abort();
		root.open = wasOpen;
	};
};
